/* index */ function _(require, module, exports) {
    require(290) /* ./polyfill */;
    var version_1 = require(296) /* ./version */;
    exports.version = version_1.version;
    var embed = require(56) /* ./embed */;
    exports.embed = embed;
    var embed_1 = require(56) /* ./embed */;
    exports.index = embed_1.index;
    var protocol = require(291) /* ./protocol */;
    exports.protocol = protocol;
    var _testing = require(295) /* ./testing */;
    exports._testing = _testing;
    var logging_1 = require(17) /* ./core/logging */;
    exports.logger = logging_1.logger;
    exports.set_log_level = logging_1.set_log_level;
    var settings_1 = require(21) /* ./core/settings */;
    exports.settings = settings_1.settings;
    var base_1 = require(0) /* ./base */;
    exports.Models = base_1.Models;
    var document_1 = require(54) /* ./document */;
    exports.documents = document_1.documents;
    var safely_1 = require(294) /* ./safely */;
    exports.safely = safely_1.safely;
}
